module.exports = "/images/cold.png?3650e19e9eb26992a83352f5b7489f40";